import { Search } from 'lucide-react'
import { CatalogSelect } from '../ui/CatalogSelect'

import { PosUseCase } from '../../services/pos.service'
import { Button } from '../ui/button'
import { SearchFilter } from '../ui/SearchFilter'

interface ProductDiscoveryControlsProps {
  search: string
  useCaseId: string
  loading: boolean
  canLoadMore: boolean
  onSearchChange: (value: string) => void
  onUseCaseChange: (value: string) => void
  onLoadMore: () => void
}

export function ProductDiscoveryControls({
  search,
  useCaseId,
  loading,
  canLoadMore,
  onSearchChange,
  onUseCaseChange,
  onLoadMore,
}: ProductDiscoveryControlsProps) {
  return (
    <>
      <div className="mb-4 grid gap-3 md:grid-cols-[minmax(0,1fr)_240px]">
        <div className="relative w-full">
          <SearchFilter
            id="product-search-input"
            initialValue={search}
            placeholder="Buscar producto por nombre o código..."
            onSearch={(value) => onSearchChange(value)}
            className="w-full"
            autoComplete="off"
          />
        </div>
        <CatalogSelect
          catalog="pos/use-cases"
          placeholder="Todos los productos"
          value={useCaseId === 'all' ? '' : useCaseId}
          onChange={(val: any) => onUseCaseChange(val || 'all')}
          className="h-10 border-slate-200"
        />
      </div>

    </>
  )
}
